export default __webpack_public_path__ + "static/media/icon-map.a042b513.svg";